export default __webpack_public_path__ + "static/media/check-circle-grey.bd6473cf.svg";